















































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import VJsonschemaForm from "@pan-gms/vuetify-jsonschema-form";
import { MigrationImport } from "@/entities";
import { Locales } from "@/i18n/locales";

const namespace: string = "migration";

@Component({
  components: {
    VJsonschemaForm,
  },
})
export default class AutoCompleteFormComponent extends Vue {
  @State(namespace) migration!: MigrationImport;
  @Action("saveMigrationData", { namespace }) saveData: any;

  @Prop() schema!: any;
  @Prop() items!: any;
  @Prop() model!: any;
  @Prop() comboField!: string;
  @Prop() label!: string;
  @Prop() icon!: string;
  @Prop() heading!: string;
  @Prop() userInfo: any;
  @Prop() comboDisplayField: string;
  data: any = {};
  dialog: boolean = false;
  disableEdit: boolean = false;
  isNew: boolean = false;
  defaultLocale: string = localStorage.getItem("language") || Locales.EN;

  get selectedValue(): any {
    return this.model[this.comboField];
  }

  get comboItems(): any {
    var self = this;

    return this.items.map(function (data) {
      let info = [];
      info.push(data.fullName);
      info.push(data.organization);
      info.push(data.email);

      let displayText = info.filter((x) => !!x).join(", ");

      return { text: displayText, value: data.email };
    });
  }

  get options() {
    return {
      disableAll: this.disableEdit && this.disableEdit === true ? true : false,
      locale: this.defaultLocale
    };
  }

  onChangeSchemaForm(e) {}

  change() {
    let self = this;
    let item = this.items[0];

    if (item) {
      // Get all key names
      let keys = Object.keys(item);

      keys.forEach(function (key) {
        self.model[key] = "";
      });
    }

    this.$emit("change", true);
  }
}
